import React from 'react';
import styled from 'styled-components';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Provider } from '../contexts/AppContext';
import Register from './Register';
import Logo from './Logo';
import Membership from './Membership';
import { Toasts } from './Toasts';

const Base = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 0.75rem;
`;

function App() {
  return (
    <Provider>
      <Base>
        <Switch>
          <Route
            path="/:groupId"
            exact
            render={({ match: { params: { groupId } } }) => (
              <Redirect to={`/${groupId}/register`} />
            )}
          />
          <Route path="/:groupId/register" exact component={Register} />
          <Route path="/:groupId/register/review" exact component={Register} />
          <Route path="/:groupId/memberships/:id" exact component={Membership} />
          <Route path="/:groupId/key/:key" exact component={Register} />
          <Route component={Logo} />
        </Switch>
        <Toasts />
      </Base>
    </Provider>
  );
}

export default App;
